<script>
import GlobalTransactionList from '../../components/global_transaction/GlobalTransactionList.vue'

export default {
  components: {
    GlobalTransactionList
  },
}
</script>


<template>
  <GlobalTransactionList
      endpoint="global_transaction/enterprise_europe"
      gateway="europe_pro"
  />
</template>
